import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import Activity from '@/components/activity'


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component:resolve =>require(['../components/HelloWorld.vue'],resolve)
    },{
      path: '/',
      name:'applist',
      component:resolve =>require(['../components/activity.vue'],resolve)
    },{
      path: '/apply',
      name:'apply',
      component:resolve =>require(['../components/apply.vue'],resolve)
    },{
      path: '/order',
      name:'order',
      component:resolve =>require(['../components/order.vue'],resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js